// Generated by scripts/generate-side-image-measurements.ps1
// Threshold: 245
// Generated at: 2026-04-27 14:01:56 -05:00

export const SIDE_IMAGE_MEASUREMENTS = {
    "Backpack_Black":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  612,
            "contentHeight":  858,
            "left":  594,
            "right":  1205,
            "top":  21,
            "bottom":  878
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  612,
            "contentHeight":  858,
            "left":  594,
            "right":  1205,
            "top":  21,
            "bottom":  878
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  452,
            "contentHeight":  858,
            "left":  224,
            "right":  675,
            "top":  21,
            "bottom":  878
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  452,
            "contentHeight":  858,
            "left":  224,
            "right":  675,
            "top":  21,
            "bottom":  878
        }
    },
    "Backpack_Brown":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  612,
            "contentHeight":  858,
            "left":  594,
            "right":  1205,
            "top":  21,
            "bottom":  878
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  612,
            "contentHeight":  858,
            "left":  594,
            "right":  1205,
            "top":  21,
            "bottom":  878
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  452,
            "contentHeight":  858,
            "left":  224,
            "right":  675,
            "top":  21,
            "bottom":  878
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  452,
            "contentHeight":  858,
            "left":  224,
            "right":  675,
            "top":  21,
            "bottom":  878
        }
    },
    "Keychain_Black":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1653,
            "contentHeight":  698,
            "left":  105,
            "right":  1757,
            "top":  133,
            "bottom":  830
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1653,
            "contentHeight":  698,
            "left":  105,
            "right":  1757,
            "top":  69,
            "bottom":  766
        }
    },
    "Keychain_Brown":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1653,
            "contentHeight":  698,
            "left":  105,
            "right":  1757,
            "top":  133,
            "bottom":  830
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1653,
            "contentHeight":  698,
            "left":  105,
            "right":  1757,
            "top":  69,
            "bottom":  766
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  785,
            "contentHeight":  321,
            "left":  94,
            "right":  878,
            "top":  276,
            "bottom":  596
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  786,
            "contentHeight":  321,
            "left":  21,
            "right":  806,
            "top":  276,
            "bottom":  596
        }
    },
    "Large_Weekender_Black":  {
        "front":  {
                    "imageWidth":  1800,
                    "imageHeight":  900,
                    "contentWidth":  1714,
                    "contentHeight":  876,
                    "left":  43,
                    "right":  1756,
                    "top":  0,
                    "bottom":  875
                },
        "back":  {
                    "imageWidth":  1800,
                    "imageHeight":  900,
                    "contentWidth":  1714,
                    "contentHeight":  876,
                    "left":  43,
                    "right":  1756,
                    "top":  0,
                    "bottom":  875
                },
        "left":  {
                    "imageWidth":  900,
                    "imageHeight":  900,
                    "contentWidth":  858,
                    "contentHeight":  875,
                    "left":  21,
                    "right":  878,
                    "top":  0,
                    "bottom":  874
                },
        "right":  {
                    "imageWidth":  900,
                    "imageHeight":  900,
                    "contentWidth":  858,
                    "contentHeight":  875,
                    "left":  21,
                    "right":  878,
                    "top":  0,
                    "bottom":  874
                }
    },
    "Large_Weekender_Brown":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1714,
            "contentHeight":  876,
            "left":  103,
            "right":  1756,
            "top":  20,
            "bottom":  875
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1714,
            "contentHeight":  876,
            "left":  43,
            "right":  1756,
            "top":  0,
            "bottom":  875
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  874,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  873
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  874,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  873
        }
    },
    "Small_Weekender_Black":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  900,
            "left":  42,
            "right":  1756,
            "top":  0,
            "bottom":  899
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  900,
            "left":  42,
            "right":  1756,
            "top":  0,
            "bottom":  899
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  900,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  899
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  900,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  899
        }
    },
"Small_Weekender_Brown":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  900,
            "left":  42,
            "right":  1756,
            "top":  0,
            "bottom":  899
                },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  900,
            "left":  42,
            "right":  1756,
            "top":  0,
            "bottom":  899
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  900,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  899
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  858,
            "contentHeight":  900,
            "left":  21,
            "right":  878,
            "top":  0,
            "bottom":  899
        }
    },
    "Toiletry_Black":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  742,
            "left":  42,
            "right":  1756,
            "top":  79,
            "bottom":  820
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1714,
            "contentHeight":  742,
            "left":  43,
            "right":  1756,
            "top":  79,
            "bottom":  820
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  832,
            "contentHeight":  773,
            "left":  21,
            "right":  852,
            "top":  64,
            "bottom":  836
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  832,
            "contentHeight":  773,
            "left":  47,
            "right":  878,
            "top":  64,
            "bottom":  836
        }
    },
    "Toiletry_Brown":  {
        "front":  {
                        "imageWidth":  1800,
                        "imageHeight":  900,
                        "contentWidth":  1714,
                        "contentHeight":  742,
                        "left":  43,
                        "right":  1756,
                        "top":  79,
                        "bottom":  820
                    },
        "back":  {
                    "imageWidth":  1800,
                    "imageHeight":  900,
                    "contentWidth":  1715,
                    "contentHeight":  742,
                    "left":  42,
                    "right":  1756,
                    "top":  79,
                    "bottom":  820
                },
        "left":  {
                    "imageWidth":  900,
                    "imageHeight":  900,
                    "contentWidth":  832,
                    "contentHeight":  773,
                    "left":  47,
                    "right":  878,
                    "top":  64,
                    "bottom":  836
                },
        "right":  {
                        "imageWidth":  900,
                        "imageHeight":  900,
                        "contentWidth":  832,
                        "contentHeight":  773,
                        "left":  21,
                        "right":  852,
                        "top":  64,
                        "bottom":  836
                    }
    },
"Zippered_Black":  {
        "front":  {
                        "imageWidth":  1800,
                        "imageHeight":  900,
                        "contentWidth":  1104,
                        "contentHeight":  879,
                        "left":  348,
                        "right":  1451,
                        "top":  0,
                        "bottom":  878
                    },
        "back":  {
                    "imageWidth":  1800,
                    "imageHeight":  900,
                    "contentWidth":  1104,
                    "contentHeight":  879,
                    "left":  348,
                    "right":  1451,
                    "top":  0,
                    "bottom":  878
                },
        "left":  {
                    "imageWidth":  900,
                    "imageHeight":  900,
                    "contentWidth":  518,
                    "contentHeight":  879,
                    "left":  191,
                    "right":  708,
                    "top":  0,
                    "bottom":  878
                },
        "right":  {
                        "imageWidth":  900,
                        "imageHeight":  900,
                        "contentWidth":  518,
                        "contentHeight":  879,
                        "left":  191,
                        "right":  708,
                        "top":  0,
                        "bottom":  878
                    },
        "top":  {
                    "imageWidth":  1800,
                    "imageHeight":  900,
                    "contentWidth":  1715,
                    "contentHeight":  804,
                    "left":  42,
                    "right":  1756,
                    "top":  48,
                    "bottom":  851
                }
    },
    "Zippered_Brown":  {
        "front":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1104,
            "contentHeight":  879,
            "left":  348,
            "right":  1451,
            "top":  0,
            "bottom":  878
        },
        "back":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1104,
            "contentHeight":  879,
            "left":  348,
            "right":  1451,
            "top":  0,
            "bottom":  878
        },
        "left":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  518,
            "contentHeight":  879,
            "left":  191,
            "right":  708,
            "top":  0,
            "bottom":  878
        },
        "right":  {
            "imageWidth":  900,
            "imageHeight":  900,
            "contentWidth":  518,
            "contentHeight":  879,
            "left":  191,
            "right":  708,
            "top":  0,
            "bottom":  878
        },
        "top":  {
            "imageWidth":  1800,
            "imageHeight":  900,
            "contentWidth":  1715,
            "contentHeight":  804,
            "left":  42,
            "right":  1756,
            "top":  48,
            "bottom":  851
        }
    }
};

// Top references use the same 3x capture scale as the existing side images.
// Their content bounds were measured from the transparent renders.
const TOP_IMAGE_MEASUREMENTS = {
    "Large_Weekender_Black": { contentWidth: 1710, contentHeight: 858, left: 45, right: 1754, top: 21, bottom: 878 },
    "Large_Weekender_Brown": { contentWidth: 1710, contentHeight: 858, left: 45, right: 1754, top: 21, bottom: 878 },
    "Small_Weekender_Black": { contentWidth: 1716, contentHeight: 858, left: 42, right: 1757, top: 21, bottom: 878 },
    "Small_Weekender_Brown": { contentWidth: 1716, contentHeight: 858, left: 42, right: 1757, top: 21, bottom: 878 },
    "Backpack_Black": { contentWidth: 1160, contentHeight: 858, left: 320, right: 1479, top: 21, bottom: 878 },
    "Backpack_Brown": { contentWidth: 1160, contentHeight: 858, left: 320, right: 1479, top: 21, bottom: 878 },
    "Toiletry_Black": { contentWidth: 1716, contentHeight: 798, left: 42, right: 1757, top: 63, bottom: 860 },
    "Toiletry_Brown": { contentWidth: 1716, contentHeight: 798, left: 42, right: 1757, top: 63, bottom: 860 },
};

Object.entries(TOP_IMAGE_MEASUREMENTS).forEach(([modelName, measurements]) => {
    SIDE_IMAGE_MEASUREMENTS[modelName].top = {
        imageWidth: 1800,
        imageHeight: 900,
        ...measurements,
    };
});
